import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { useUserInformation } from 'graphQL/Zustand/useUserInformation';
import { HostBusinessInfoState, MeData } from 'graphQL/Auth/types';
import { getEnvConstant } from 'constants/env';
import {
  SETTLEMENT_BANK_REGIST_PATH,
  SETTLEMENT_REGIST_PATH,
  SETTLEMENT_REQUEST_PATH,
} from 'constants/path';
import { useMutationRequestHostBusinessInfoInspection } from '../graphQL/hooks/useMutationRequestHostBusinessInfoInspection';
import HackleManager from 'utils/hackle';
import { useGetMe } from 'graphQL/Auth/user/useGetMe';

export const useSettlementHooks = () => {
  const myInfo: MeData = useUserInformation((state: any) => state.userInfo);
  const navigate = useNavigate();

  const [isRegistRequest, setIsRegistRequest] = useState<boolean>(false);
  const { handleRequestHostBusinessInfoInspection } =
    useMutationRequestHostBusinessInfoInspection();
  const { handleRefetchUser } = useGetMe();

  const sendSlackNotification = async () => {
    const url =
      getEnvConstant('envName') === 'production'
        ? '/services/T02T6BYE2/B076JC18TD3/L8Yrew680Z6qyUnqXAKxFDyn'
        : '/services/T02T6BYE2/B07666HGF17/yInMPLYdzcDWCgY6IGmge8OQ';

    const payload = {
      text: `[호스트 어드민] 호스트가 검수 요청을 하였습니다.
ID: ${myInfo.me.host?.id}
link: https://admin-v3.frip.co.kr/host/list/${myInfo.me.host?.id}`,
    };

    const form = new FormData();
    form.append('payload', JSON.stringify(payload));

    const instance = axios.create({
      baseURL: 'https://hooks.slack.com',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    try {
      const response = await instance.post(url, form);
      return response.data === 'ok';
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const requestMessage = () => {
    handleRequestHostBusinessInfoInspection(myInfo.me.host?.id, async () => {
      await handleRefetchUser();
      sendSlackNotification();
      setIsRegistRequest(true);
      HackleManager.logSettlementRequestApprovalComplete();
      window.showToast('정산 정보 검수요청이 완료되었습니다.', 'success');
    });
  };

  const handleNavigateBack = () => {
    navigate(SETTLEMENT_REQUEST_PATH);
  };

  const handleSettlementRegistNavigate = () => {
    navigate(SETTLEMENT_REGIST_PATH);
  };

  const handleRegistBankPageNavigate = () => {
    navigate(SETTLEMENT_BANK_REGIST_PATH, { state: { isModify: false } });
  };

  useEffect(() => {
    window.handlePageBackwardNavigate = handleNavigateBack;
    setIsRegistRequest(
      myInfo.me.host?.settlement?.businessInfo?.status ===
        HostBusinessInfoState.INSPECTING,
    );
  }, [myInfo.me.host]);

  return {
    myInfo,
    isRegistRequest,
    handleNavigateBack,
    requestMessage,
    handleSettlementRegistNavigate,
    handleRegistBankPageNavigate,
  };
};
